export var getRedirectToComplaintUrl = function getRedirectToComplaintUrl(urlOrId, email) {
  var parametersRaw = Array.of(['openPopup', '1'], !!email && ['userEmailPopup', email]).filter(function (p) {
    return !!p;
  });
  var parameters = new URLSearchParams(parametersRaw);
  var parametersCompiled = parameters.toString();
  var match = urlOrId.match(/\.cian\.ru\/(sale|rent)\/(flat|suburban|commercial)\/(\d+)(\/|\?|#)?/);
  if (match) {
    return "/".concat(match[1], "/").concat(match[2], "/").concat(match[3], "/?").concat(parametersCompiled);
  }
  return "/sale/flat/".concat(Number(urlOrId), "/?").concat(parametersCompiled);
};